export default {
  meta: {
    title: '我的练习记录',
    url: '/abside/trainingrecord',
    urlName: 'ab侧-我的练习记录',
    logincallback: '/abside',
  }
};
